import React, { useState, useContext, useCallback, memo, useEffect } from "react";
import Calendar, { returnType } from "bodycodi/cmap/app/components/cmap2010/calendar/calendar";
import Drawer from "@material-ui/core/Drawer";

import { addZero, callApi } from "bodycodi/cmap/app/js/common";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import { Holiday } from "bodycodi/cmap/app/type";

type ChooseDateProp = {
  scheduleType: string;
  chooseDate: any;
  data: any;
  children: any;
  updateData: (d: any) => void;
};

const EditEtcCalendarWrap = (prop: ChooseDateProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [title, setTitle] = useState("");
  const { scheduleType }: ChooseDateProp = prop;

  useEffect(() => {
    if (scheduleType === "OT") {
      setTitle("OT 스케줄 변경");
    } else if (scheduleType === "CS") {
      setTitle("상담 스케줄 변경");
    } else {
      setTitle("기타 스케줄 변경");
    }
  }, [scheduleType]);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "EDIT_ETC_CALENDAR_POP",
      open: { editEtcCalendarPop: false },
    });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.editEtcCalendarPop}
      onClose={handleClose}
      className="picker-pop max"
    >
      <PickerHeader title={title} onClose={handleClose} />
      {state.editEtcCalendarPop && <EditEtcCalendar {...prop} />}
    </Drawer>
  );
};

const EditEtcCalendar = ({ chooseDate, updateData, children }: ChooseDateProp) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const date = new Date();
  const [scheduleDate, setScheduleDate] = useState({
    year: chooseDate.year || date.getFullYear(),
    month: chooseDate.month - 1 || date.getMonth(),
  });
  const [holidays, setHolidays] = useState<number[]>([]);

  useEffect(() => {
    callApi(
      "/schedule/reservation/view-holiday",
      {
        searchDate: `${scheduleDate.year}-${addZero(scheduleDate.month + 1)}-01`,
        seqPartnerCoach,
        seqPartner,
        seqPartnerBranch,
        seqPassInfo: "",
      },
      "POST"
    ).then((res) => {
      const holidayObj: { [key: number]: string } = {};
      const holiday = res.map((v: Holiday) => {
        const day = parseInt(v.dayOff.substring(8, 10));
        holidayObj[day] = v.holidayType;
        return day;
      });
      setHolidays(holiday);
    });
  }, [scheduleDate.month, scheduleDate.year]);

  const clickDate = useCallback(({ year, month, date }: returnType) => {
    updateData({
      chooseDate: {
        year,
        month,
        date,
      },
    });
  }, []);

  return (
    <div className="picker-body choose-date-pop add-schedule-pop-wrap">
      <div className="add-schedule-pop">
        <div className="title">날짜 선택</div>
        <Calendar
          onClick={clickDate}
          onChangeMonth={setScheduleDate}
          holidays={holidays}
          scheduletStateList={{}}
          isAddStep={false}
          hasTodayBtn={false}
          chooseDate={chooseDate}
        />
      </div>
      {children}
    </div>
  );
};

export default memo(EditEtcCalendarWrap);
